<template>
    <header class="header">
        <a class="header__button--cta hidden-xxl" @click.prevent="toggleMobileMenu" v-if="$store.getters.isAuthenticated">
            <i class="mdi mdi-menu"></i>
            <span class="hidden-xs">{{ $t('menu.menu') }}</span>
        </a>

        <div class="container" >
            <router-link :to="{ name: 'evaluation-students' }" class="header__logo">
                <img :src="logo" alt="Mijnportfolio" title="Mijnportfolio" height="32px">
            </router-link>

            <nav class="nav" :class="{ 'is-active': showMobileMenu }" v-if="$store.getters.isAuthenticated">
                <span class="nav__close" @click="toggleMobileMenu"><i class="mdi mdi-close"></i>{{$t('menu.close')}}</span>
                <ul>
                    <li class="nav__item">
                        <router-link :to="{ name: 'evaluation-students' }" @click.native="toggleMobileMenu" class="nav__link">{{$t('menu.evaluation_students')}}</router-link>
                    </li>
                    <li class="nav__item">
                        <router-link :to="{ name: 'pending-evaluations' }" @click.native="toggleMobileMenu" class="nav__link">{{$t('menu.pending_evaluations')}}</router-link>
                    </li>
                </ul>
                <a v-if="$store.getters.isAuthenticated" @click.prevent="signOut" class="nav__button--link visible-xs" >{{$t('menu.sign_out')}}</a>
            </nav>

            <a v-if="$store.getters.isAuthenticated" @click.prevent="signOut" class="header__button header__logout" >{{$t('menu.sign_out')}}</a>
        </div>

    </header>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import vMediaQuery from 'v-media-query';

    Vue.use(vMediaQuery);

    @Component({
        watch: {
            '$mq.resize': 'hideMobileMenu',

            showMobileMenu: function(newVal) {
                const className = 'nav__mobile_open';
                if (newVal) {
                    document.body.classList.add(className);
                } else {
                    document.body.classList.remove(className);
                }
            }
        }
    })
    export default class TheHeader extends Vue{
        name = 'the-header';
        showMobileMenu = false;

        get logo() {
            return this.$route.name === 'homepage' || this.$route.name === 'sign-in' ? '/static/img/logo--student.svg' : '/static/img/logo.png';
        }

        toggleMobileMenu() {
            if (this.$mq.below(1400)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }
        }

        showInterestedModal () {
            this.$modal.show('interested-modal');
        }

        hideMobileMenu() {
            if (this.$mq.above(1399)) {
                this.showMobileMenu = false;
            }
        }

        created() {
            this.showMobileMenu = false;
        }

        signOut() {
            this.$auth.signOut().then(() => {
                this.$router.replace({
                    name: 'sign-in'
                });
            });
        }
    }

    Vue.component('the-header', TheHeader);
</script>



// WEBPACK FOOTER //
// src/components/general/TheHeader.vue